import React from 'react';
import { Link } from "react-router-dom";
import Navbar from "../inc/Navbar";
import fb from "../images/fb2.jpg";

import Linkdin from "../images/linkdin.jpg";
import Instagram from "../images/insta.jpg";
import ScrollToTop from "react-scroll-to-top"
import { Typewriter } from 'react-simple-typewriter'
import tanmaysarkar from "../images/Tanmay Sarkar photo.jpg";

import Angularjs from "../images/angularjs.jpg"
import css from "../images/css.jpg";
import Firebase from "../images/firebase.jpg";
import Html from "../images/html.jpg";
import Nodejs from "../images/nodejs.jpg";
import Pythan from "../images/pythan.jpg";
import Reactjs from "../images/react.jpg"
import Js from "../images/javasripts.jpg";
import Flutter from "../images/flutter.jpg";
import Yourube from "../images/youtube-logo.jpg";

import mak from "../images/Mountaineers’ Association of Krishnanagar.jpg";



import mbdharandsonjewellers from "../images/MBDHAR.jpg";
import Rupaecobrickphoto from "../images/rupaecobrick.jpg";
import MaryImmaculateSchoolAlumniAssociation from "../images/MISAA-LOGO.jpg";
import maklogo from "../images/mak.org.in.jpg";

import paulshotel from "../images/paulshotelkrishnagar.jpg";
import prothama from "../images/PROTHAMA - KRISHNAGAR.jpg";
import questdiagnosticskrishnagar from "../images/QUEST DIAGNOSTICS KRISHNANAGAR.jpg";


import manmohini from "../images/manmohibi.jpg";
import siddheswaribastralaya from "../images/siddheshwari bastralaya.jpg";
import drsankarkumarroy from "../images/drsankarkumarroy.jpg";
import desertmina from "../images/Desertmina.jpg";

import KrishnagarPublicSchool from "../images/Krishnagar Public School.jpg";
import AristacureBiotechprivatelimited from "../images/Aristacure Biotech Private Limited.jpg";
import balajisaree from "../images/BALAJI SAREE.jpg";
import sushadu from "../images/sushadu.jpg";

import unicornaerocitykolkata from "../images/unicornaerogreens.jpg"

// import Fileupload from "../pages/Fileupload";
import Rupaecobrick from "../images/rupaecbrick-debopriya gope.jpg"

import Studentpage from "../pages/Studentpage";
// import Uploadfile from "../pages/Uploadfile";
import Develop from "../pages/Develop";

import ReactWhatsapp from "react-whatsapp";

import './Home.css'
import Reviews from './Reviews';
import Sliderinvite from './Sliderinvite';
import Slidermisaa from './Slidermisaa';
import { Contactformnew } from './ContactfromNew';


function Home() {
    return (
        <>
            <Navbar />
            <br />
            <br />
            <br />
            <br />

            <div className='homebackground'>
                <div className="album py-2">
                    <div className="container">

                        <div className="row">
                            <div className="col-md-6 mt-3">
                                <div className='backradius'>
                                    <img src={tanmaysarkar} className="d-block w-100 mb-2" alt="bestwebsitedevelopmentinnadia" />
                                </div>

                                <div className="album py-0">
                                    <div className="container">
                                        <h2 className='mb-0' style={{ color: "grey" }}> Grateful to be Invited to the Grand Opening Ceremony of <b>G.P. Premia Showroom</b> </h2>
                                        <h6 style={{ color: "#A57040" }}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-geo-alt" viewBox="0 0 16 16">
                                            <path d="M12.166 8.94c-.524 1.062-1.234 2.12-1.96 3.07A32 32 0 0 1 8 14.58a32 32 0 0 1-2.206-2.57c-.726-.95-1.436-2.008-1.96-3.07C3.304 7.867 3 6.862 3 6a5 5 0 0 1 10 0c0 .862-.305 1.867-.834 2.94M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10" />
                                            <path d="M8 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4m0 1a3 3 0 1 0 0-6 3 3 0 0 0 0 6" />
                                        </svg> NH-12, BHATJANGLA, KRISHNAGAR</h6>
                                    </div>
                                </div>

                                <Sliderinvite />
                            </div>
                            <div className="col-md-6 mt-3">
                                <iframe src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fmrindiancoder&tabs=timeline&width=500&height=700&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId" width="100%" height="630" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>

                            </div>
                        </div>

                    </div>
                </div>
                <br />
            </div>
            <ScrollToTop smooth top="100" style={{ margin: "8px" }} color="Gray" />



            <div style={{ color: "Green", display: 'flex', justifyContent: 'flex-start', margin: "3px" }} className="fixed-bottom  mb-1"> <ReactWhatsapp number="+91 9933798896" className="whatsAppicon" message="I would like to get a professional website developed."> <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" class="bi bi-whatsapp" viewBox="0 0 16 16">
                <path d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z" />
            </svg>   </ReactWhatsapp></div>


            <div className='Kalyaniwebsite'>
                <div className="album py-2">
                    <div className="container">
                        <h2 style={{ color: "#037383" }}><b>Our Development Services Are Trusted by Hon’ble MSMEs and Clients </b></h2>
                    </div>
                </div>

                <div className="album py-0">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-6">
                                <div className="d-flex justify-content-start align-items-center mb-2">
                                    <div className="col-md-6 me-2 mt-3">
                                        <div className='cardmotation'>
                                            <div className="card">
                                                <a href='https://www.mbdharandsonjewellers.com/' target='_blank' rel="noopener noreferrer">
                                                    <img id="myimage" src={mbdharandsonjewellers} className="card-img-top" alt="Mantasa" />
                                                </a>

                                            </div>
                                        </div>

                                    </div>
                                    <div className="col-md-6  mt-3">
                                        <div className='cardmotation'>
                                            <div className="card">
                                                <a href='https://www.rupaecobrick.com/' target='_blank' rel="noopener noreferrer">
                                                    <img src={Rupaecobrickphoto} className="card-img-top" alt="Rupaecobrick" />
                                                </a>

                                            </div>
                                        </div>

                                    </div>

                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="d-flex justify-content-start align-items-center mb-2">
                                    <div className="col-md-6 me-2 mt-3">
                                        <div className='cardmotation'>
                                            <div className="card">
                                                <a href='https://misaa.org.in/' target='_blank' rel="noopener noreferrer">

                                                    <img src={MaryImmaculateSchoolAlumniAssociation} className="card-img-top" alt="Mary Immaculate School Alumni Association" />

                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6  mt-3">
                                        <div className='cardmotation'>
                                            <div className="card">
                                                <a href='https://www.mak.org.in/' target='_blank' rel="noopener noreferrer">
                                                    <img src={maklogo} className="card-img-top" alt="Mountaineers’ Association of Krishnanagar" />
                                                </a>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div className="album py-0">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-6">
                                <div className="d-flex justify-content-start align-items-center mb-2">
                                    <div className="col-md-6 me-2 mt-3">
                                        <div className='cardmotation'>
                                            <div className="card">
                                                <a href='https://www.paulshotel.com/' target='_blank' rel="noopener noreferrer">
                                                    <img id="myimage" src={paulshotel} className="card-img-top" alt="paulshotel Krishnagar" />
                                                </a>

                                            </div>
                                        </div>

                                    </div>
                                    <div className="col-md-6  mt-3">
                                        <div className='cardmotation'>
                                            <div className="card">
                                                <a href='https://www.prothama.com/' target='_blank' rel="noopener noreferrer">
                                                    <img src={prothama} className="card-img-top" alt="prothama" />

                                                </a>
                                            </div>
                                        </div>

                                    </div>

                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="d-flex justify-content-start align-items-center mb-2">
                                    <div className="col-md-6 me-2 mt-3">
                                        <div className='cardmotation'>
                                            <div className="card">
                                                <a href='https://www.questdiagnostics.org.in/' target='_blank' rel="noopener noreferrer">

                                                    <img src={questdiagnosticskrishnagar} className="card-img-top" alt="questdiagnostics" />

                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6  mt-3">
                                        <div className='cardmotation'>
                                            <div className="card">
                                                <a href='https://www.unicornaerogreens.com/' target='_blank' rel="noopener noreferrer">
                                                    <img src={unicornaerocitykolkata} className="card-img-top" alt="unicornaerocitykolkata" />

                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                <div className="album py-0">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-6">
                                <div className="d-flex justify-content-start align-items-center mb-2">
                                    <div className="col-md-6 me-2 mt-3">
                                        <div className='cardmotation'>
                                            <div className="card">
                                                <a href='https://www.kpsnadia.org/' target='_blank' rel="noopener noreferrer">
                                                    <img id="myimage" src={KrishnagarPublicSchool} className="card-img-top" alt="KrishnagarPublicSchool" />
                                                </a>

                                            </div>
                                        </div>

                                    </div>
                                    <div className="col-md-6  mt-3">
                                        <div className='cardmotation'>
                                            <div className="card">
                                                <a href='https://www.drsankarkumarroy.com/' target='_blank' rel="noopener noreferrer">

                                                    <img src={drsankarkumarroy} className="card-img-top" alt="drsankarkumarroy" />

                                                </a>
                                            </div>
                                        </div>

                                    </div>

                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="d-flex justify-content-start align-items-center mb-2">
                                    <div className="col-md-6 me-2 mt-3">
                                        <div className='cardmotation'>
                                            <div className="card">
                                                <a href='https://www.aristacurebiotech.com/' target='_blank' rel="noopener noreferrer">

                                                    <img src={AristacureBiotechprivatelimited} className="card-img-top" alt="AristacureBiotechprivatelimited" />

                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6  mt-3">
                                        <div className='cardmotation'>
                                            <div className="card">
                                                <a href='https://www.sushadu.com/' target='_blank' rel="noopener noreferrer">
                                                    <img src={sushadu} className="card-img-top" alt="sushadu" />

                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div className="album py-0">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-6">
                                <div className="d-flex justify-content-start align-items-center mb-2">
                                    <div className="col-md-6 me-2 mt-3">
                                        <div className='cardmotation'>
                                            <div className="card">
                                                <a href='https://www.manmohini.com/' target='_blank' rel="noopener noreferrer">
                                                    <img id="myimage" src={manmohini} className="card-img-top" alt="manmohini" />
                                                </a>

                                            </div>
                                        </div>

                                    </div>
                                    <div className="col-md-6  mt-3">
                                        <div className='cardmotation'>
                                            <div className="card">
                                                <a href='https://www.siddheswaribastralaya.com/' target='_blank' rel="noopener noreferrer">
                                                    <img src={siddheswaribastralaya} className="card-img-top" alt="siddheswaribastralaya" />

                                                </a>
                                            </div>
                                        </div>

                                    </div>

                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="d-flex justify-content-start align-items-center mb-2">
                                    <div className="col-md-6 me-2 mt-3">
                                        <div className='cardmotation'>
                                            <div className="card">
                                                <a href='https://www.desertmina.com/' target='_blank' rel="noopener noreferrer">
                                                    <img src={desertmina} className="card-img-top" alt="desertmina" />

                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6  mt-3">
                                        <div className='cardmotation'>
                                            <div className="card">
                                                <a href='https://www.balajisaree.com/' target='_blank' rel="noopener noreferrer">
                                                    <img src={balajisaree} className="card-img-top" alt="balajisaree" />

                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <br />
                <div className="container">
                    <div className="d-flex justify-content-end align-items-end mb-0">
                        <a href='our-development'>
                            <button className='nadiawebsitedevelopment mt-1'>Read More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                                <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                            </svg></button>
                        </a>
                    </div>
                </div>
                <br />

            </div>
            <div className="p-2 mb-0 bg-light text-dark">


                <div className="album py-1">

                    <div className="container">

                        <div className="row">

                            <div className="col-md-6 mt-3 me-0" >

                                <div className="radiustanmaycoder">
                                    <div className='hoverimagecoder'>
                                        <img src={Rupaecobrick} className="card-img-top image5" alt="Rupaecobrick" />
                                        <div className="bestwebsitedeveloperwestbengal ">MR. INDIAN CODER</div>
                                    </div>
                                </div>
                                <div className="d-flex justify-content-between align-items-center">
                                </div>

                            </div>
                            <div className="col-md-6 mt-3" >
                                <h2 style={{ textAlign: "center", color: "Gray" }}> <b>MR. INDIAN CODER</b> with RUPA ECO BRICK OWNER Debapriya Gope</h2>
                                <p style={{ textAlign: "center", color: "Darkblue" }} > Our Develop Website : <Link to="/our-development" className="btn btn-light" target="_blank"
                                    rel="noopener noreferrer">
                                    CLICK HERE
                                </Link>
                                </p>
                                <br />
                                <p style={{ olor: "#563D1F" }}>Our Development Website Live - Berhampore-Murshidabad, Kolkata,  Karimpur, Krishnanagar-Nadia, Purba Bardhaman (West Bengal) | India's Famous & Trusted Website Developer </p>
                                <p>Feel free to get in touch with me today to discuss your project.</p>
                                <br />
                                <h5 className='mb-3'>Contact Information:</h5>
                                <div className="d-flex justify-content-between align-items-center">
                                    <a href="tel: +91 9933798896" className="buttonnav mb-2">
                                        <div className='' style={{ color: "white" }}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone-forward" viewBox="0 0 16 16">
                                                <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511zm10.762.135a.5.5 0 0 1 .708 0l2.5 2.5a.5.5 0 0 1 0 .708l-2.5 2.5a.5.5 0 0 1-.708-.708L14.293 4H9.5a.5.5 0 0 1 0-1h4.793l-1.647-1.646a.5.5 0 0 1 0-.708z" />
                                            </svg> +91 9933798896*

                                        </div>
                                    </a>
                                </div>

                            </div>
                        </div>
                    </div>
                    <br />
                </div>

                <Develop />

                <div className="album py-0">
                    <div className="container">
                        <h1 style={{ color: "grey" }}> Reviews from Our Hon'ble Clients</h1>
                    </div>
                </div>
                <Reviews />




            </div>



            <div style={{
                backgroundImage: "url(" + "https://i.postimg.cc/QMQRXsH4/txmrM7.jpg" + ")",
                backgroundPosition: 'center',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat'
            }}>
                <br />
                <br />
                <center>
                    <Link to="/coding" className="buttoncoding button2">India’s Most Trusted Website Developer <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" class="bi bi-code-slash" viewBox="0 0 16 16">
                        <path d="M10.478 1.647a.5.5 0 1 0-.956-.294l-4 13a.5.5 0 0 0 .956.294l4-13zM4.854 4.146a.5.5 0 0 1 0 .708L1.707 8l3.147 3.146a.5.5 0 0 1-.708.708l-3.5-3.5a.5.5 0 0 1 0-.708l3.5-3.5a.5.5 0 0 1 .708 0zm6.292 0a.5.5 0 0 0 0 .708L14.293 8l-3.147 3.146a.5.5 0 0 0 .708.708l3.5-3.5a.5.5 0 0 0 0-.708l-3.5-3.5a.5.5 0 0 0-.708 0z" />
                    </svg> <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" class="bi bi-check-circle-fill" viewBox="0 0 16 16">
                            <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                        </svg></Link></center>
                <div className="album py-1">

                    <div className="container">

                        <div className="row">
                            <center>
                                <h1 style={{ fontSize: "2rem", color: "Gray" }} className="card-text mb-4"> A Trusted Name in Website Development Across India</h1>
                            </center>
                            <h1 style={{ color: "Darkblue", fontSize: "3rem" }} className="card-text"> <b>INDIA'S FAMOUS WEBSITE DEVELOPER</b></h1>

                        </div>
                    </div>
                </div>
                <br />
                <br />
                <br />




                <div className="album py-2">

                    <div className="container">

                        <div className="row">


                            < p className="card-text " style={{ margin: "auto 0", color: "dark" }}> <b> Expert In :  <span style={{ fontWeight: "bold", marginleft: '10px', color: "Darkblue" }}>
                                <Typewriter
                                    loop
                                    cursor
                                    cursorStyle="_"
                                    typeSpeed={100}
                                    deleteSpeed={50}
                                    delaySpeed={1000}
                                    words={["Website Development", "Web Design", "Photoshop", "Backend Software", "React Js Website Development", "Android & IOS App"]}
                                />
                            </span>
                            </b></p>
                        </div>
                    </div>
                </div>
                <br />
                <br />


                <br />


                <div className="album py-2">

                    <div className="container">

                        <div className="row">
                            <div className="indiastrustedwebsitedevelopment">
                                <h1 style={{ fontSize: "4rem" }} className="card-text mb-8"> <b>MR. INDIAN CODER</b></h1>
                            </div>
                        </div>
                    </div>
                </div>
                <br />



            </div>

            {/* <img src={ MRINDIANCODER} class="img-fluid" width="1350" height="1000"  alt=" MR. INDIAN CODER"></img> */}
            {/* <Uploadfile/>
<br/>
<Fileupload/> */}

            {/* <Sliders/> */}
            <div className="backgroundc">

                <div className="album py-0">

                    <div className="container">

                        <div className="row">
                            <div className="col-md-7">

                                <div className="card-body">

                                    <h1 className="card-text mb-2" style={{ paddingTop: "1rem", margin: "auto 0", color: "Gray" }}> <b>  <span style={{ color: "white", fontWeight: "bold", marginleft: '7px' }}>
                                        <Typewriter
                                            loop
                                            cursor
                                            cursorStyle="_"
                                            typeSpeed={90}
                                            deleteSpeed={50}
                                            delaySpeed={1000}
                                            words={[" HEALTHCARE WEBSITE", " EDUCATION WEBSITE", "GOVT. WEBSITE", "SINGER WEBSITE", "BUSINESS WEBSITE", "VLOG WEBSITE", "PERSONAL BRAND WEBSITE", "CORPORATE WEBSITE", "PHOTOGRAPHER WEBSITE"]}
                                        />
                                    </span>
                                    </b></h1>

                                    <p className="mrindiancoderlive mb-2">The website of your dreams will be improved and faster</p>

                                </div>


                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <div className="p-0 mb-0 bg-secondary text-light">
                <div className="album py-2">

                    <div className="container">

                        <div className="row">
                            <h1> Best React JS Website Development Company in West Bengal</h1>
                        </div>
                    </div>
                </div>
            </div>
            <div className="album py-4">

                <div className="container">

                    <div className="row">

                        <div className="col-md-4 mt-8" >
                            <div className="card mb-4 border-White box">

                                <div className="card-body">

                                    <h6 className="card-text"> <b>Singer World Wide Website</b></h6>
                                    <p className="card-text">Even after delivering your website, we remain available 24/7 for support.</p>


                                </div>
                            </div>

                        </div>
                        <div className="col-md-4 mt-6" >
                            <div className="card mb-4 border-White box">

                                <div className="card-body">
                                    <h6 className="card-text"><b>Public School Website</b></h6>
                                    <p className="card-text">Experience lightning-fast navigation — pages open in less than 1 second.</p>

                                </div>
                            </div>

                        </div>
                        {/* style={{textAlign: "center"}} */}
                        <div className="col-md-4" >
                            <div className="card mb-4 border-White box">
                                <Link to="/Jewellers" target='_blank'>
                                    {/* <img src={Jewellersweb} className="card-img-top"   alt="jewellerswebsite" /> */}
                                </Link>
                                <div className="card-body">
                                    <h6 className="card-text"><b>Jewellers & Dimond Website</b></h6>
                                    <p className="card-text"> Build Professional Websites in Minutes — Fast, Reliable, and Efficient</p>


                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <div className='misaa'>
                <br />
                <div className="album py-1">
                    <div className="container">
                        <h1 className='mb-0' style={{ color: "grey" }}> Honoured to be Invited to the <b>M.I.S.A.A</b> Annual Re-Union 2024</h1>
                        <p><a className='mb-0' href='https://www.misaa.org.in/' target="_blank" rel="noopener noreferrer">https://www.misaa.org.in/</a></p>
                    </div>
                </div>

                <Slidermisaa />

                <br />
                <a href='our-development'>
                    <h2 style={{ textAlign: "center" }} className="card-text">  <div className="buttoncoding button2" > Our Best Work - CLICK NOW  </div></h2>
                </a>
                <br />

            </div>
            <center>
                <h1 className="mb-2" style={{ paddingTop: "2rem", margin: "auto 0", color: "Gray" }}> <b> Our  <span style={{ color: "Gray", fontWeight: "bold", marginleft: '10px' }}>
                    <Typewriter
                        loop
                        cursor
                        cursorStyle="_"
                        typeSpeed={90}
                        deleteSpeed={50}
                        delaySpeed={1000}
                        words={["Servies", " Services"]}
                    />
                </span>
                </b></h1>
                <p className="mb-5" >WE PROVIDE BEST SERVICES & SOLUTIONS</p>
            </center>


            <div className="mrindiancoder_global">

                <div className="album py-4">

                    <div className="container">

                        <div className="row">
                            <div className="col-md-4">
                                <div className="card mb-4 border-white box ">

                                    <div class="card text-center">
                                        <div class="card-body">
                                            <h5 class="card-title">Payment Gateway</h5>
                                            <p class="card-text">Affordable web design services in India, includes payment gateway for easy online transfer from any customer (debit/ credit…etc) account to your account for any sales website does.</p>
                                            <br />
                                        </div>
                                    </div>
                                    <div className="d-flex justify-content-between align-items-center">
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="card mb-4 border-white box ">
                                    <div class="card text-center">
                                        <div class="card-body">
                                            <h5 class="card-title">Web Development</h5>
                                            <p class="card-text">We develop website on highly optimized codes. We have in expertise team of developers with the expertise on the demanding technologies, frameworks, tools.</p>
                                            <br /><br />
                                        </div>
                                    </div>
                                    <div className="d-flex justify-content-between align-items-center">
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="card mb-4 border-white box ">

                                    <div class="card text-center">
                                        <div class="card-body">
                                            <h5 class="card-title">Responsive Design</h5>
                                            <p class="card-text">Get your device responsive website to reach your potential audience across all the devices. We have expertise in trending technologies, frameworks, tools for to make website Fully mobile responsive.</p>
                                            <br />
                                        </div>
                                    </div>
                                    <div className="d-flex justify-content-between align-items-center">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <img src={HealthD} className="card-img-top" alt="HealthD"/> */}
            </div>
            <div className='krishnagarwebsitedevelper'>
                <br />
                <div className="album py-0">
                    <div className="container">
                        <h1 className='mb-0' style={{ color: "grey" }}>It Was a Pleasure to Be Invited to the <b>MAK (Mountaineers’ Association of Krishnanagar)</b> Get-Together 2024</h1>
                        <p><a className='mb-0' href='https://www.mak.org.in/' target="_blank" rel="noopener noreferrer">https://www.mak.org.in/</a></p>
                    </div>
                </div>
                <div className="album py-1">
                    <div className="container">
                        <div className='mak_krishnagar'>
                            <img src={mak} className="d-block w-100" alt="Mountaineers’ Association of Krishnanagar" />
                        </div>
                    </div>
                </div>
                <br />
            </div>

            <center>
                <h1 className="mb-1" style={{ paddingTop: "2rem", margin: "auto 0", color: "Deepblack" }}> <b> Become a Website Development  <span style={{ color: "Gray", fontWeight: "bold", marginleft: '10px' }}>
                    <Typewriter
                        loop
                        cursor
                        cursorStyle="_"
                        typeSpeed={90}
                        deleteSpeed={50}
                        delaySpeed={1000}
                        words={["Marchent", " Tycoon"]}
                    />
                </span>
                </b></h1>
                <br />
                <div className="choos">
                    <h1 style={{ color: "Gray", }} className=" mb-4" >Why Choose Us?</h1>
                </div>
            </center>
            <div className="album py-2">

                <div className="container">

                    <div className="row">

                        <div className="col-md-6 mt-6" >


                            <h5 style={{ color: "Gray" }} className="card-text texts mb-3">The Vision of MR. INDIAN CODER is  to deliver our unique website
                                developemnt blend and value to each corner of the  world.</h5>


                            <h5 className='texts' style={{ color: "Gray" }}  > Distributor partners of MR. INDIAN CODER are enjoying <b>huge margins </b> and impeccable growth every year. It's easy to get started with tested, tried and high_ROI driven business models. Now currently the demand
                                for creating websites in 2022 is increasing. The industry has <b>huge growth </b>potential.</h5>
                            <br />
                            <br />
                            <Link to="/franchise" target='_blank'>
                                <button type="buttonbookfranchise" className="buttonbookfranchise mb-3">
                                    <b className='mb-1'> Book Franchise <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-double-right" viewBox="0 0 16 16">
                                        <path fill-rule="evenodd" d="M3.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L9.293 8 3.646 2.354a.5.5 0 0 1 0-.708" />
                                        <path fill-rule="evenodd" d="M7.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L13.293 8 7.646 2.354a.5.5 0 0 1 0-.708" />
                                    </svg></b>
                                </button>
                            </Link>
                            <div className="d-flex justify-content-between align-items-center">


                            </div>

                        </div>
                        <div className="col-md-6 mt-6" >

                            <Develop />



                            <div className="d-flex justify-content-between align-items-center">

                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <br />
            <div class="p-2 mb-2 bg-light text-dark">
                <div className="album py-4">

                    <div className="container">

                        <div className="skill">
                            <h1 className=" skill mb-2"><center> <b>Our Skill</b></center></h1>
                        </div>

                        <p className="card-text"><center>We are always updated for the progress of your business.</center></p>

                    </div>
                </div>

            </div>
            <div className="album py-4">

                <div className="container">

                    <div className="row">

                        <div className="col-md-4 mt-3" >

                            <div className="card mb-4 border-White shadow">
                                <img src={Reactjs} className="card-img-top" alt="Reactjsdevelopernadia,westbengal" />
                                <div className="card-body">

                                    <h6 className="card-text texts"> <b><center>React – A JavaScript library for building user interfaces</center></b></h6>
                                    <p className="card-text texts"><small> 74.5% of developers recommend to use reactjs, it is one of the most loved frameworks. There are so many tools that help in web and app development but among all only a few are preferred by the enterprises. Facebook's ReactJS is one of them. </small> </p>
                                    <div className="d-flex justify-content-between align-items-center">



                                    </div>
                                </div>
                            </div>


                        </div>
                        <div className="col-md-4 mt-3" >
                            <div className="card mb-4 border-white box shadow">
                                <img src={Nodejs} className="card-img-top" alt="Nodejsdeveloperinwestbengal" />
                                <div className="card-body">
                                    <h6 className="card-text texts"><b> Node.js® is a JavaScript runtime built on Chrome's V8 JavaScript engine. </b></h6>
                                    <p className="card-text">Node.js is an open-source, cross-platform, back-end JavaScript runtime environment that runs on the V8 engine and executes JavaScript code outside a web browser. </p>
                                    <br />
                                    <div className="d-flex justify-content-between align-items-center">


                                    </div>
                                </div>
                            </div>

                        </div>

                        <div className="col-md-4 mt-3" >
                            <div className="card mb-4 border-white box shadow">
                                <img src={Pythan} className="card-img-top" alt="Pythan" />
                                <div className="card-body">
                                    <h6 className="card-text"> <b> Python is a High-level programming language</b></h6>
                                    <p className="card-text texts"> What is Python used for? Python is a computer programming language often used to build websites and software, automate tasks, and conduct data analysis.</p>
                                    <br />
                                    <div className="d-flex justify-content-between align-items-center">



                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="col-md-4 mt-3">
                            <div className="card mb-4 border-white box shadow">
                                <img src={Html} className="card-img-top" alt="Html-css-developerinwestbengal,nadia" />
                                <div className="card-body">
                                    <h6 className="card-text"><b><center>The HyperText Markup Language, HTML(Programming language)</center></b></h6>
                                    <p className="card-text texts"> The HyperText Markup Language or HTML is the standard markup language for documents designed to be displayed in a web browser. It can be assisted by technologies such as Cascading Style Sheets and scripting languages such as JavaScript. </p>
                                    <div className="d-flex justify-content-between align-items-center">


                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="col-md-4 mt-3">
                            <div className="card mb-4 border-white box shadow">
                                <img src={css} className="card-img-top" alt="bestjewellerswebsitedevelopmentinwestbengal" />
                                <div className="card-body">
                                    <h6 className="card-text"><b><center>Cascading Style Sheets is a style sheet language</center></b></h6>
                                    <p className="card-text texts">  Cascading Style Sheets is a style sheet language used for describing the presentation of a document written in a markup language such as HTML. CSS is a cornerstone technology of the World Wide Web, alongside HTML and JavaScript. </p>
                                    <div className="d-flex justify-content-between align-items-center">


                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="col-md-4 mt-3">
                            <div className="card mb-4 border-white box shadow">
                                <img src={Firebase} className="card-img-top" alt="Firebase" />
                                <div className="card-body">
                                    <h6 className="card-text"><b><center>Google Firebase is a Google-backed application development software </center></b></h6>
                                    <p className="card-text texts">  Firebase is a platform developed by Google for creating mobile and web applications. It was originally an independent company founded in 2011. In 2014, Google acquired the platform it is now their flagship offering for app development</p>
                                    <div className="d-flex justify-content-between align-items-center">


                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="col-md-4 mt-3">
                            <div className="card mb-4 border-white box shadow">
                                <img src={Js} className="card-img-top" alt="Js" />
                                <div className="card-body">
                                    <h6 style={{ textAlign: "center" }} className="card-text"> <b>JavaScript is a Programming language</b></h6>
                                    <p className="card-text texts"> JavaScript, often abbreviated JS, is a programming language that is one of the core technologies of the World Wide Web, alongside HTML and CSS. Over 97% of websites use JavaScript on the client side for web page behavior, often incorporating third-party libraries. </p>

                                    <div className="d-flex justify-content-between align-items-center">



                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="col-md-4 mt-3">
                            <div className="card mb-4 border-white box shadow">
                                <img src={Flutter} className="card-img-top" alt="Flutter" />
                                <div className="card-body">
                                    <h6 style={{ textAlign: "center" }} className="card-text"><b>Flutter - Build apps for any screen</b></h6>
                                    <p className="card-text texts">Flutter is an open-source UI software development kit created by Google. It is used to develop cross platform applications for Android, iOS, Linux, macOS, Windows, Google Fuchsia, and the web from a single codebase. First described in 2015, Flutter was released in May 2017. </p>

                                    <div className="d-flex justify-content-between align-items-center">


                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="col-md-4 mt-3">
                            <div className="card mb-4 border-white box shadow">
                                <img src={Angularjs} className="card-img-top" alt="reactjswebsitedeveloperinwb" />
                                <div className="card-body">
                                    <h6 className="card-text"><b><center>AngularJS is a JavaScript framework</center></b></h6>
                                    <p className="card-text texts"> AngularJS was a JavaScript-based open-source front-end web framework for developing single-page applications. It was maintained mainly by Google and a community of individuals and corporations. <br />
                                        Developer(s): Google
                                    </p>
                                    <br />
                                    <div className="d-flex justify-content-between align-items-center">


                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <br />

            {/* <Uploadfile/> */}
            {/* <Fileupload/> */}
            <Studentpage />
            <br />

            <br />
            <br />








            <center><h2 style={{ textAlign: "center", color: "Darkblue" }} ><b>Follow Me</b></h2></center>
            <div className="album py-4">

                <div className="container">

                    <div className="row">

                        <div className="col-md-3 mt-3" >

                            <div className="card mb-4 border-white box  ">
                                <a href="https://www.facebook.com/profile.php?id=100084747566591"
                                    target="_blank"
                                    rel="noopener noreferrer" >

                                    <img src={fb} className="card-img-top" alt="fb" />
                                </a>
                                <div className="card-body">
                                    <center>
                                        <h6 className="card-text"><b style={{ textAlign: "center", color: "Gray" }}>Like, Share & Comment</b></h6>
                                    </center>
                                    <div className="d-flex justify-content-between align-items-center">

                                    </div>
                                </div>
                            </div>
                        </div>


                        {/* style={{textAlign: "center"}} */}
                        <div className="col-md-3 mt-3">
                            <div className="card mb-4 border-white box ">
                                <a href="https://www.linkedin.com/company/mr-indian-coder/"
                                    target="_blank"
                                    rel="noopener noreferrer">
                                    <img src={Linkdin} className="card-img-top" alt="Linkdin" /></a>
                                <div className="card-body">
                                    <center>
                                        <h6 className="card-text"><b style={{ textAlign: "center", color: "Gray" }}>Like, Share & Comment</b></h6>
                                    </center>




                                    <div className="d-flex justify-content-between align-items-center">


                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="col-md-3 mt-3" >
                            <div className="card mb-4 border-white box ">
                                <a href="https://www.instagram.com/mrindiancoder/"
                                    target="_blank"
                                    rel="noopener noreferrer">
                                    <img src={Instagram} className="card-img-top" alt="Instagram" /></a>
                                <div className="card-body">
                                    <center>
                                        <h6 className="card-text"><b style={{ textAlign: "center", color: "Gray" }}> Like, Share & Comment</b></h6>
                                    </center>

                                    <div className="d-flex justify-content-between align-items-center">


                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="col-md-3 mt-3">
                            <div className="card mb-4 border-white box ">
                                <a href="https://www.youtube.com/@MR.INDIAN-CODER/"
                                    target="_blank"
                                    rel="noopener noreferrer">
                                    <img src={Yourube} className="card-img-top" alt="Yourube" /></a>
                                <div className="card-body">
                                    <center>
                                        <h6 className="card-text"><b style={{ textAlign: "center", color: "Gray" }}> Like, Share & Comment</b></h6>
                                    </center>

                                    <div className="d-flex justify-content-between align-items-center">


                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
            </div>
            <div className="album py-2">

                <div className="container">

                    <div className='card'>
                        
                            
                            <Contactformnew/>
                       
                    </div>
                </div>
            </div>
            <br />


        </>

    );
}

export default Home;